'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Image from 'next/image';
import { Avatar } from '@udemy-v2/react-core-components';
import classNames from 'classnames';
import styles from './community-powered-badge.module.scss';
export type CommunityPoweredBadgeSize = 'sm' | 'lg';
const ASSET_BASE = (process.env.ASSET_PREFIX ?? '').replace(/\/$/, '');
const COMMUNITY_POWERED_BADGE_SM = `${ASSET_BASE}/community-powered-sm-en-us-v1.png`;
export interface CommunityPoweredBadgeProps {
  imageUrl: string;
  displayName: string;
  url?: string;
  onClick?: () => void;
  size?: CommunityPoweredBadgeSize;
  className?: string;
  'data-purpose'?: string;
}
export function CommunityPoweredBadge(t0) {
  const $ = _c(28);
  const {
    imageUrl,
    displayName,
    url,
    onClick,
    size: t1,
    className,
    "data-purpose": t2
  } = t0;
  const size = t1 === undefined ? "lg" : t1;
  const dataPurpose = t2 === undefined ? "instructor-image" : t2;
  const t3 = size === "sm" ? 60 : 154;
  const t4 = size === "sm" ? 60 : 154;
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = <Image className={styles["community-powered"]} src={COMMUNITY_POWERED_BADGE_SM} alt="" width={t3} height={t4} unoptimized={true} />;
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = size === "sm" ? styles["avatar-sm"] : styles["avatar-lg"];
  let t7;
  if ($[3] !== t6) {
    t7 = classNames(styles.avatar, t6);
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== displayName || $[6] !== imageUrl) {
    t8 = {
      display_name: displayName,
      image_200_H: imageUrl
    };
    $[5] = displayName;
    $[6] = imageUrl;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t7 || $[9] !== t8) {
    t9 = <Avatar className={t7} user={t8} srcKey="image_200_H" alt="NONE" />;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t5 || $[12] !== t9) {
    t10 = <>{t5}{t9}</>;
    $[11] = t5;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const content = t10;
  const t11 = size === "sm" ? styles["badge-container-sm"] : styles["badge-container-lg"];
  let t12;
  if ($[14] !== className || $[15] !== t11) {
    t12 = classNames(styles["badge-container"], t11, className);
    $[14] = className;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const containerClassName = t12;
  if (url) {
    let t13;
    if ($[17] !== containerClassName || $[18] !== content || $[19] !== dataPurpose || $[20] !== displayName || $[21] !== onClick || $[22] !== url) {
      t13 = <a href={url} onClick={onClick} target="_blank" rel="noopener noreferrer" className={containerClassName} data-purpose={dataPurpose} aria-label={displayName}>{content}</a>;
      $[17] = containerClassName;
      $[18] = content;
      $[19] = dataPurpose;
      $[20] = displayName;
      $[21] = onClick;
      $[22] = url;
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    return t13;
  }
  let t13;
  if ($[24] !== containerClassName || $[25] !== content || $[26] !== dataPurpose) {
    t13 = <div className={containerClassName} data-purpose={dataPurpose}>{content}</div>;
    $[24] = containerClassName;
    $[25] = content;
    $[26] = dataPurpose;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}